module.exports = __webpack_public_path__ + "img/五星特级大师@2x.6f3cb050.png";